import NriFaqBanner from './NriFaqBanner';
import NriFaqSection from './NriFaqSection';

function NriFaq() {
  return (
    <div>
      <NriFaqBanner />
      <NriFaqSection />
    </div>
  );
}

export default NriFaq;